import { render, staticRenderFns } from "./CreateCampaignWrapper.vue?vue&type=template&id=61049f9b&scoped=true"
import script from "./CreateCampaignWrapper.vue?vue&type=script&lang=js"
export * from "./CreateCampaignWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61049f9b",
  null
  
)

export default component.exports